var FilterService = (function () {
    'use strict';

    function loadFilters() {
        $.get('/api/v7/filters', function (response) {
            let el = $('.js-filters-modal');
            while (el[0].firstChild) {
                el[0].removeChild(el[0].firstChild);
            }
            if(response.result.items.length > 0)
                openModal();

            $.each(response.result.items, function (idx, item) {
                var group =
                    `<div class="col-xs-12 col-lg-6">
                        <div class="title">
                            ${item.filterGroupTitle}
                        </div>
                        <div class="choices">
                            ${item.filterGroupType === 'Single' ? render(item, renderSingleChoiceFilter) : render(item, renderMultipleChoiceFilter)}
                        </div>
                </div>`;
                el.append(group);
            });
            initializeFilterHandlers();
        })
    }

    function openModal(){
        $('.modal.in').modal('hide');
        $('#filtersModal').modal('show');
    }

    function cancel(){
        applyFilters();
    }

    function render(item, callback) {
        var html = '';
        $.each(item.filters, function (idx, filter) {
            html += callback(filter, item.id);
        });
        return html;
    }

    function renderSingleChoiceFilter(filter, name) {
        return `
                    <label class="container">
                        ${filter.title}
                        <input type="radio" name="${name}" value="${filter.id}">
                        <span class="checkmark"></span>
                    </label>`;

    }
    

    function renderMultipleChoiceFilter(filter, name) {
        return `
                <div class="choice-container">
                    <span class="choice">
                        <button type="button" class="btn">${filter.title}</button>
                        <input type="checkbox" class="hidden" name="filters[]" value="${filter.id}" />
                    </span>
                </div>`;
    }

    function initializeFilterHandlers() {
        $('.choice').each(function () {

            var $widget = $(this),
                $button = $widget.find('button'),
                $checkbox = $widget.find('input:checkbox');

            $button.click(function () {
                $checkbox.prop('checked', !$checkbox.is(':checked'));
                $checkbox.triggerHandler('change');
                updateDisplay();
            });

            $checkbox.on('change', function () {
                updateDisplay();
            });

            function updateDisplay() {
                var isChecked = $checkbox.is(':checked');

                $button.data('state', (isChecked) ? "on" : "off");
                if (isChecked) {
                    $button
                        .removeClass('btn')
                        .addClass('btn active');
                } else {
                    $button
                        .removeClass('btn active')
                        .addClass('btn');
                }
            }
        });
    }

    function fillChosenFilters(chosenFilters, el) {
        el.each(function () {
            var widget = $(this);
            var checkbox = widget.find('input:checkbox');
            var isChecked = checkbox.is(':checked');
            if (isChecked) {
                chosenFilters.push(checkbox.val());
            }
            var radio = widget.find('input:radio');
            var isChecked = radio.is(':checked');
            if (isChecked) {
                chosenFilters.push(radio.val());
            }
        })
    }

    function applyFilters(){
        var chosenFilters = [];
        fillChosenFilters(chosenFilters, $('.choice'));
        fillChosenFilters(chosenFilters, $('.container'));
        $.get("/site-api/filters", function (response) {
            var category = $('.js-dishes-list').data('category-path');
            if (chosenFilters.length !== 0) {
                window.location.href = "/goods/" + category + "?appliedFilters=" + chosenFilters;
            } else {
                window.location.href = "/goods/" + category;
            }
        });
    }

    function init() {
        $('.js-open-filters').not(".active").click(loadFilters);

        $('.js-open-filters.active').click(cancel);

        $('.js-filters-apply').click(applyFilters);


        $('.loyalty-program').hover(function(){
                $('.navbar-loyalty-program-hover').css({'display': 'inline-block'}).stop().animate({opacity: 1},300); 
        }, function(){
            $('.navbar-loyalty-program-hover').stop().animate({bottom: '50px',opacity: 0}, 200,
                function(){
                $('.navbar-loyalty-program-hover').css({'display': 'none'});
        });
        });
    }

    return {
        init: init,
    };
})();

$(FilterService.init);